<template>
  <v-data-table-server :headers="headers" :items="listData.users" :items-length="pagination.totalItems"
    :loading="listData.loading" :items-per-page="pagination.itemsPerPage"
    :items-per-page-options="pagination.perPageOptions" v-model:page="pagination.currentPage"
    v-model:items-per-page="pagination.itemsPerPage" @update:options="$emit('load-items', $event)"
    mobile-breakpoint="sm" class="elevation-0 data-table-modern rounded-lg">

    <template v-slot:loading>
      <v-skeleton-loader class="mx-auto" max-width="100%" type="table-row@3"></v-skeleton-loader>
    </template>
    <template v-slot:loader>
    </template>

    <template v-slot:no-data>
      <div v-if="listData.error" class="text-center py-8">
        <v-icon size="64" color="danger-color" class="mb-4">mdi-alert-circle</v-icon>
        <h3 class="text-title-large text-danger-color mb-2">Error Loading Users</h3>
        <p class="text-body-medium text-grey-darken-1 mb-4">
          {{ listData.message || 'Failed to load users. Please try again.' }}
        </p>
        <v-btn color="danger-color" variant="outlined" @click="$emit('load-items', {})">
          <v-icon left>mdi-refresh</v-icon>
          Retry
        </v-btn>
      </div>
      <div v-else class="text-center py-8">
        <v-icon size="64" color="grey-lighten-1" class="mb-4">mdi-account-group</v-icon>
        <h3 class="text-title-large text-grey-darken-1 mb-2">No Users Found</h3>
        <p class="text-body-medium text-grey-darken-1 mb-0">
          No users match your current search criteria.
        </p>
      </div>
    </template>

    <template v-slot:[`item.serial_no`]="{ item }">
      {{ ((pagination.currentPage - 1) * pagination.itemsPerPage) + listData.users.indexOf(item) + 1 }}
    </template>

    <template v-slot:[`item.name`]="{ item }">
      <router-link v-if="userRolesMethod(item.roles) !== 'Administrator'" class="text-brand-color py-4"
        :to="{ name: 'users.edit', params: { id: item.id } }">
        <v-badge :color="item.active ? 'success' : 'error'" dot class="cursor-pointer">
          <v-tooltip location="bottom">
            <template v-slot:activator="{ props }">
              <div v-bind="props">
                <v-icon icon="mdi-account" size="default" :color="item.active ? 'success' : 'error'"></v-icon>
              </div>
            </template>
            <span>{{ item.active ? 'Active User' : 'Suspended User' }}</span>
          </v-tooltip>
        </v-badge>
        &nbsp;
        {{ item.name }}
      </router-link>
      <span v-else class="py-4">
        <v-badge :color="item.active ? 'success' : 'error'" dot class="cursor-pointer">
          <v-tooltip location="bottom">
            <template v-slot:activator="{ props }">
              <div v-bind="props">
                <v-icon icon="mdi-account" size="default" :color="item.active ? 'success' : 'error'"></v-icon>
              </div>
            </template>
            <span>{{ item.active ? 'Active User' : 'Suspended User' }}</span>
          </v-tooltip>
        </v-badge>
        &nbsp;
        <v-tooltip location="top">
          <template v-slot:activator="{ props }">
            <span v-bind="props" class="text-brand-color cursor-not-allowed">
              {{ item.name }}
            </span>
          </template>
          <span>Administrator account settings can't be accessed</span>
        </v-tooltip>
      </span>
    </template>

    <template v-slot:[`item.email`]="{ item }">
      <div class="d-flex align-start ga-2">
        <v-badge :color="item.verified ? 'success' : 'warning'" dot class="cursor-pointer mt-1">
          <v-tooltip location="bottom">
            <template v-slot:activator="{ props }">
              <div v-bind="props">
                <v-icon icon="mdi-email" size="default" :color="item.verified ? 'success' : 'warning'"></v-icon>
              </div>
            </template>
            <span>{{ item.verified ? 'Verified' : 'Unverified' }}</span>
          </v-tooltip>
        </v-badge>
        <span class="email-cell" :title="item.email">{{ item.email }}</span>
      </div>
    </template>

    <template v-slot:[`item.role`]="{ item }">
      <v-chip :color="getRoleChipColor(item.roles)" variant="tonal" size="small" class="font-weight-medium"
        rounded="lg">
        {{ userRolesMethod(item.roles) }}
      </v-chip>
    </template>

    <template v-slot:[`item.subscription`]="{ item }">
      <span class="subscription">
        {{ subscriptionMethods.getUserSubscriptionTitle(item) }}
        <template v-if="subscriptionMethods.getUserSubscriptionStatus(item)">
          <br>
          ({{ subscriptionMethods.getUserSubscriptionStatus(item) }})
        </template>
      </span>
    </template>

    <template v-slot:[`item.forms_count`]="{ item }">
      <v-chip color="brand-color" variant="tonal" rounded="pill">{{ item.forms_count || 0 }}</v-chip>
    </template>

    <template v-slot:[`item.user_leads_count`]="{ item }">
      <v-chip color="info" variant="tonal" rounded="pill">{{ item.user_leads_count || 0 }}</v-chip>
    </template>

    <template v-slot:[`item.created_at`]="{ item }">
      {{ localeDate(item.created_at) }}
    </template>
  </v-data-table-server>
</template>

<script>
import helperMixin from '@/mixins/helper'
import userMixin from '@/mixins/user'

export default {
  mixins: [helperMixin, userMixin],
  props: {
    pagination: {
      type: Object,
      required: true
    },
    headers: {
      type: Array,
      required: true
    },
    listData: {
      type: Object,
      required: true
    },
    userRolesMethod: {
      type: Function,
      required: true
    },
    subscriptionMethods: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.email-cell {
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
  min-width: 0;
}
</style>
